/* NN Photo – sends the product form to the theme's own cart drawer instead of the cart page */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || !form.classList || !form.classList.contains('nn-pdp__form')) return;
  var add = form.querySelector('.nn-pdp__add');
  if (e.submitter && e.submitter !== add) return;
  if (!window.jQuery || !window.adev || !window.adev.cartDrawer || !window.fetch) return;
  e.preventDefault();
  var label = add.textContent;
  add.disabled = true;
  add.textContent = 'Добавяне…';
  var data = new FormData(form);
  data.append('sections', 'adev-cart-drawer,cart-icon-bubble');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      add.disabled = false;
      add.textContent = label;
      if (d.status) { form.submit(); return; }
      jQuery(document).trigger('adev:cart:drawer:refresh', d.sections);
      jQuery(document).trigger('adev:open:drawer', 'cart-drawer');
    })
    .catch(function () { form.submit(); });
});
